import EditIcon from '@mui/icons-material/Edit';
import { GridActionsCellItem, getGridDateOperators, getGridNumericOperators } from '@mui/x-data-grid-premium';
import React from 'react';

import { dayjs, formatCurrency, isOwnerPortal } from '../../../utils';

const dateOperators = getGridDateOperators();
const numericOperators = getGridNumericOperators();

export const getInvoiceHistoryColumns = (timezone: string) => [
	{
		field: 'createdAt',
		headerName: 'Transaction Date',
		type: 'date',
		flex: 1,
		valueGetter: (params) => {
			if (!params.value) return null;
			return dayjs
				.utc(params.value)
				.tz(timezone || 'America/Chicago')
				.toDate();
		},
		renderCell: (params) => {
			if (!params.value) return null;
			return dayjs(params.value)
				.tz(timezone || 'America/Chicago')
				.format('M/D/YYYY h:mm A');
		},
		filterOperators: dateOperators,
	},
	{
		field: 'applicationDate',
		headerName: 'Application Date',
		type: 'date',
		flex: 1,
		valueGetter: (params) => {
			if (!params.value) return null;
			return new Date(params.value.slice(0, -1));
		},
		renderCell: (params) => {
			if (!params.value) return null;
			return dayjs.utc(params.value).format('M/D/YYYY');
		},
	},
	{
		field: 'applicationType',
		headerName: 'Type',
		type: 'string',
		flex: 1,
		width: 250,
	},
	{
		field: 'creditNumber',
		headerName: 'Credit ID',
		type: 'string',
		flex: 1,
		renderCell: (params) => {
			if (!params.row.creditNumber) return null;
			const { creditId } = params.row;
			return (
				<a
					target='_blank'
					style={{ color: 'blue' }}
					href={`/credit-detail/?creditId=${creditId}`}
					rel='noreferrer'
				>
					{params.row.creditNumber}
				</a>
			);
		},
	},
	{
		field: 'paymentId',
		headerName: 'Payment ID',
		type: 'string',
		flex: 1,
	},
	{
		field: 'paymentBatches',
		headerName: 'Payment Batch',
		renderCell: (params) => {
			if (params.row.paymentBatch) {
				return (
					<a
						target='_blank'
						style={{ color: 'blue' }}
						rel='noreferrer'
						href={`/payment-application/details/?id=${params.row.paymentBatch}`}
					>
						{params.row.paymentBatch}
					</a>
				);
			}
			return '-';
		},
		width: 150,
	},
	{
		field: 'displayAmount',
		headerName: 'Amount',
		type: 'number',
		flex: 1,
		filterOperators: numericOperators,
		valueGetter: (params) => {
			if (!params.row.amount) return null;
			return params.row.amount / 100;
		},
		renderCell: (params) => params.row.displayAmount,
	},
	{
		field: 'currentBalance',
		headerName: 'Current Balance',
		type: 'number',
		flex: 1,
		filterOperators: numericOperators,
		valueGetter: (params) => {
			if (params.row.rowType === 'CREDIT') return null;
			return params.row.currentBalance / 100;
		},
		renderCell: (params) => {
			if (params.row.rowType === 'CREDIT') return null;
			return formatCurrency(params.value);
		},
	},
	{
		field: 'creditDisplayAmount',
		headerName: 'Credit Amount',
		type: 'number',
		flex: 1,
		filterOperators: numericOperators,
		valueGetter: (params) => {
			if (!params.row.creditAmount) return null;
			return params.row.creditAmount / 100;
		},
		renderCell: (params) => params.row.creditDisplayAmount,
	},
	{
		field: 'notes',
		headerName: 'Transaction Notes',
		type: 'string',
		flex: 1,
	},
	{
		field: 'actions',
		type: 'actions',
		headerName: isOwnerPortal ? 'View Notes' : 'Edit Notes',
		width: 100,
		cellClassName: 'actions',
		renderCell: () => (
			<GridActionsCellItem
				key='edit'
				icon={<EditIcon data-cy='edit-notes-icon' />}
				label='Edit'
				className='textPrimary'
				color='inherit'
			/>
		),
	},
];
